import React, { useEffect } from 'react';
import Template from '../../Template/Template';
import BankCautionIcon from 'src/assets/images/bank_caution-icon.svg';
import { dispatchPageLoad } from '../../../../../redux/utils/analytics-helper';

const Denial = () => {
  useEffect(() => {
    dispatchPageLoad('VerificationExceededAttempts');
  }, []);
  return (
    <Template
      hasPDF
      image={BankCautionIcon}
      header={`We are unable to verify your bank`}
      msg={
        'You have exceeded the number of attempts to verify this bank. You can try to verify this bank again in 72 hours.'
      }
      nextButton={`View Account Services Form`}
      nextDestination={
        'https://individual.troweprice.com/staticFiles/Retail/Shared/PDFs/shrhldrsrvcs.pdf'
      }
    />
  );
};

export default Denial;
